<script setup>
import { useHead } from '@unhead/vue';
import BrandForm from '../../scripts/components/contactForm/BrandForm.vue';
import CarouselGeneric from '../../scripts/components/CarouselGeneric.vue';

const imagesGlob = import.meta.glob('../../images/brands/travismathew/*', { eager: true });

useHead({});

const products = [
	{
		src: imagesGlob['../../images/brands/travismathew/crestview-quarter-zip.jpg'].default,
		title: 'Crestview Quarter Zip'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/cold-bay-vest.jpg'].default,
		title: 'Cold Bay Vest'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/coveside-hoodie.jpg'].default,
		title: 'Coveside Hoodie'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/long-weekend-crew.jpg'].default,
		title: 'Long Weekend Crew'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/balboa-hooded-full-zip-jacket.jpg'].default,
		title: 'Balboa Hooded Full-Zip Jacket'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/lateral-duffel.jpg'].default,
		title: 'Lateral Duffel'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/coto-performance-polo.jpg'].default,
		title: 'Coto Performance Polo'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/recess-backpack.jpg'].default,
		title: 'Recess Backpack'
	},
	{
		src: imagesGlob['../../images/brands/travismathew/cruz-trucker-cap.jpg'].default,
		title: 'Cruz Trucker Cap'
	},
]
</script>

<template lang="pug">
.page.page--brand.travismathew
	section.hero
		.hero__bg
		.hero__content
			.copy
				img(src='@static/images/brands/travismathew/logo.svg')
				h1 Custom TravisMathew
			.image
				img(src='@static/images/brands/travismathew/hero.png' alt="Two models wearing TravisMathew apparel sitting on pink rock formations under a clear blue sky.")
	section.section.section--subhero
		.section__content
			.copy
				h3 Live One of a Kind
				p Rooted in the California lifestyle, custom TravisMathew by Swagger fuses laid-back elegance with high-performance innovation, offering apparel that thrives both on and off the course. Designed for those who value both style and substance, this curated collection features versatile pieces that move with you through every moment of your day. From sun up to sun down, TravisMathew is committed to crafting premium, functional products that reflect a passion for quality, sustainability, and the pursuit of a life well lived.
	.page__content
		section.section.section--products
			.section__content
				CarouselGeneric(name="productCarousel" :innerNav="false" :perPage="{ 0: 1, 751: 3 }")
					.product-card(v-for="product in products")
						.product-card__image
							img(:src="product.src" :alt="`Custom TravisMathew ${product.title}`")
						.product-card__text
							p {{product.title}}
							

		
		section.section.section--form
			.section__content
				h2 Love this brand?<br/>Let's make something cool together
				p Please fill out this form so we can help you with your upcoming project.
				.form-wrap
					BrandForm(formName="travismathew")
		
		section.section.section--detail
			.stripe
				img(src='@static/images/brands/travismathew/banner.png' alt="Two models wearing TravisMathew quilted jackets walking along a rocky shoreline at sunset.")
			.section__content
				.copy
					h2 The Fabric &amp; Technology
					p TravisMathew combines innovative fabrics with elevated style, making it the perfect choice for modern gifting. Designed to deliver supreme comfort, easy care, and versatile wearability, these pieces are ideal for teams, clients, and events where quality matters. Whether it’s a quick-dry Heater Series polo or a wrinkle-resistant everyday essential, TravisMathew ensures your gifts make a lasting impression, and gets worn again and again.
		
		section.section.section--foot
			.bg
			.section__content
				.pack
					.item
						img(src='@static/images/brands/travismathew/easy.png' alt="Icon of a shirt with steam lines over light blue textured fabric background, representing TravisMathew’s easy-care, machine-washable performance fabric.")
						p Lifestyle Performance
					.item
						img(src='@static/images/brands/travismathew/4way.png' alt="Diamond-shaped icon with arrows pointing in four directions and the number “4” in the center over black textured fabric, symbolizing TravisMathew’s flexible, 4-way stretch Heater Series fabric.")
						p Heater Series
					.item
						img(src='@static/images/brands/travismathew/wrinkle.png' alt="Outline of an iron with a diagonal line through it over navy blue textured fabric, denoting TravisMathew’s ultra-soft, wrinkle-resistant Cloud fabric.")
						p Cloud
					.item
						img(src='@static/images/brands/travismathew/eco.png' alt="Circular leaf icon with “The Eco Collection by TravisMathew” text over teal textured fabric, highlighting the brand’s eco-friendly, sustainable fabric collection.")
						p Eco
		
</template>

<style></style>